// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-calendar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  bottom: 0;
  left: 50%;
  background-color: #ffffff00;
}


.days-row {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  width: 700px;
  margin-left: 40px;
  margin-top: 20px;
  color: #ffffff;
  padding-top: 10px;
  padding-bottom: 10px;
  margin-bottom: -5px;
}

.day {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  border: 2px solid #ffffff;
  background-color: rgba(71, 194, 188, 0.397);
  padding: 3px;
}

.calendar-navigation-container {
  display: flex;
  justify-content: center;
  align-items: center;
  bottom: 0;
  width: 100%;
  background-color: #ffffff00;
  margin-top: 60px;
}

.calendar-days {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 18px;
  width: auto;
}

.calendar-day {
  width: calc(100% - 10px);
  height: calc(100% - 10px);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #0000002f;
  cursor: pointer;
  position: relative;
  margin: 12px;
  padding: 12px;
  font-size: 30px;
  color: #056175;
}

.calendar-day::before {
  content: "";
  display: inline-block;
  vertical-align: middle;
  height: 100%;
}

.calendar-day span {
  display: inline-block;
  vertical-align: middle;
  z-index: 1;
}

.calendar-day:not(.placeholder) {
  border-color: #056175;
}

.calendar-header {
  text-align: center;
  font-size: 25px;
  margin-bottom: 10px;
}


.navigation-icon {
  font-size: 16px;
  width: 40px;
  height: 40px;
  border: 1px solid transparent;
  border-radius: 50%;
  border-color: #757575;
  transition: background-color 0.3s ease-in-out;
  color: #757575;
  margin: 8px;
}

.navigation-icon:hover {
  background-color: #5A9BD8;
  border-color: #5A9BD8;
  color: #5A9BD8;
}

.navigation-icon.selected {
  color: #47c2bb;
  border: 1px solid rgba(71, 194, 188, 0.349);
  background-color: rgba(71, 194, 187, 0.12);
}

.navigation-icon.selected:hover {
  border-color: #5A9BD8;
  color: #5A9BD8;
  background-color: #5A9BD8;
}

.calendar-day.selected {
  background-color: #00000027;
  color: #fff;
}

.calendar-day.selectedDates {
  background-color: #c0121223;
  color: #fff;
}

.calendar-day {
  position: relative;
}

.calendar-day.unavailable {
  background-color: rgb(248, 2, 2);
  color: white;
}

.calendar-day.unavailable:hover::after {
  content: "Holiday";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  padding: 8px;
  background-color: rgb(248, 2, 2);
  color: #fff;
  border-radius: 0.5rem;
  white-space: nowrap;
  font-size: 14px;
}

.small-edit-icon {
  svg {
    width: 18px;
    height: 18px;
  }
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
}

.small-delete-icon {
  svg {
    width: 18px;
    height: 18px;
  }
  top: 0;
  left: 0;
  z-index: 2;
}

.calendar-day.current-date {
  background-color: rgb(1, 117, 126);
  color: #fff;
}

.calendar-day.current-date:hover::after {
  content: "Today";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  padding: 1px;
  padding-top: 11px;
  padding-bottom: 11px;
  background-color: rgb(1, 117, 126);
  color: #fff;
  white-space: nowrap;
  font-size: 14px;
}

.calendar-day.available {
  background-color: #47c2bc34;
  color: rgba(0, 0, 0, 0.651);
}

.calendar-day.selected {
  background-color: rgba(71, 194, 187, 0.12);
  color: #fff;
}

.calendar-day.selectedDates {
  background-color: rgba(0, 0, 0, 0.12);
  color: #030000d3;
}
`, "",{"version":3,"sources":["webpack://./src/Components/Calendar/CalendarView.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,SAAS;EACT,2BAA2B;AAC7B;;;AAGA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,2CAA2C;EAC3C,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;;AAGA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,qBAAqB;EACrB,6CAA6C;EAC7C,cAAc;EACd,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,2CAA2C;EAC3C,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,gCAAgC;EAChC,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;EACA,MAAM;EACN,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,kCAAkC;EAClC,WAAW;EACX,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,gBAAgB;AAClB","sourcesContent":[".custom-calendar {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  bottom: 0;\r\n  left: 50%;\r\n  background-color: #ffffff00;\r\n}\r\n\r\n\r\n.days-row {\r\n  display: grid;\r\n  grid-template-columns: repeat(7, 1fr);\r\n  width: 700px;\r\n  margin-left: 40px;\r\n  margin-top: 20px;\r\n  color: #ffffff;\r\n  padding-top: 10px;\r\n  padding-bottom: 10px;\r\n  margin-bottom: -5px;\r\n}\r\n\r\n.day {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100%;\r\n  border: 2px solid #ffffff;\r\n  background-color: rgba(71, 194, 188, 0.397);\r\n  padding: 3px;\r\n}\r\n\r\n.calendar-navigation-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  bottom: 0;\r\n  width: 100%;\r\n  background-color: #ffffff00;\r\n  margin-top: 60px;\r\n}\r\n\r\n.calendar-days {\r\n  display: grid;\r\n  grid-template-columns: repeat(7, 1fr);\r\n  gap: 18px;\r\n  width: auto;\r\n}\r\n\r\n.calendar-day {\r\n  width: calc(100% - 10px);\r\n  height: calc(100% - 10px);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border: 1px solid #0000002f;\r\n  cursor: pointer;\r\n  position: relative;\r\n  margin: 12px;\r\n  padding: 12px;\r\n  font-size: 30px;\r\n  color: #056175;\r\n}\r\n\r\n.calendar-day::before {\r\n  content: \"\";\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  height: 100%;\r\n}\r\n\r\n.calendar-day span {\r\n  display: inline-block;\r\n  vertical-align: middle;\r\n  z-index: 1;\r\n}\r\n\r\n.calendar-day:not(.placeholder) {\r\n  border-color: #056175;\r\n}\r\n\r\n.calendar-header {\r\n  text-align: center;\r\n  font-size: 25px;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n\r\n.navigation-icon {\r\n  font-size: 16px;\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 1px solid transparent;\r\n  border-radius: 50%;\r\n  border-color: #757575;\r\n  transition: background-color 0.3s ease-in-out;\r\n  color: #757575;\r\n  margin: 8px;\r\n}\r\n\r\n.navigation-icon:hover {\r\n  background-color: #5A9BD8;\r\n  border-color: #5A9BD8;\r\n  color: #5A9BD8;\r\n}\r\n\r\n.navigation-icon.selected {\r\n  color: #47c2bb;\r\n  border: 1px solid rgba(71, 194, 188, 0.349);\r\n  background-color: rgba(71, 194, 187, 0.12);\r\n}\r\n\r\n.navigation-icon.selected:hover {\r\n  border-color: #5A9BD8;\r\n  color: #5A9BD8;\r\n  background-color: #5A9BD8;\r\n}\r\n\r\n.calendar-day.selected {\r\n  background-color: #00000027;\r\n  color: #fff;\r\n}\r\n\r\n.calendar-day.selectedDates {\r\n  background-color: #c0121223;\r\n  color: #fff;\r\n}\r\n\r\n.calendar-day {\r\n  position: relative;\r\n}\r\n\r\n.calendar-day.unavailable {\r\n  background-color: rgb(248, 2, 2);\r\n  color: white;\r\n}\r\n\r\n.calendar-day.unavailable:hover::after {\r\n  content: \"Holiday\";\r\n  position: absolute;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  padding: 8px;\r\n  background-color: rgb(248, 2, 2);\r\n  color: #fff;\r\n  border-radius: 0.5rem;\r\n  white-space: nowrap;\r\n  font-size: 14px;\r\n}\r\n\r\n.small-edit-icon {\r\n  svg {\r\n    width: 18px;\r\n    height: 18px;\r\n  }\r\n  position: absolute;\r\n  top: 0;\r\n  right: 0;\r\n  z-index: 2;\r\n}\r\n\r\n.small-delete-icon {\r\n  svg {\r\n    width: 18px;\r\n    height: 18px;\r\n  }\r\n  top: 0;\r\n  left: 0;\r\n  z-index: 2;\r\n}\r\n\r\n.calendar-day.current-date {\r\n  background-color: rgb(1, 117, 126);\r\n  color: #fff;\r\n}\r\n\r\n.calendar-day.current-date:hover::after {\r\n  content: \"Today\";\r\n  position: absolute;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  padding: 1px;\r\n  padding-top: 11px;\r\n  padding-bottom: 11px;\r\n  background-color: rgb(1, 117, 126);\r\n  color: #fff;\r\n  white-space: nowrap;\r\n  font-size: 14px;\r\n}\r\n\r\n.calendar-day.available {\r\n  background-color: #47c2bc34;\r\n  color: rgba(0, 0, 0, 0.651);\r\n}\r\n\r\n.calendar-day.selected {\r\n  background-color: rgba(71, 194, 187, 0.12);\r\n  color: #fff;\r\n}\r\n\r\n.calendar-day.selectedDates {\r\n  background-color: rgba(0, 0, 0, 0.12);\r\n  color: #030000d3;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
